// Issue #75: 初期パスワードのまま利用しているユーザーへ、ログイン後に
// パスワード変更を促す警告を表示する（操作はブロックしない・8秒で自動クローズ）
// Issue #76: 画面中央をマスクで覆う Modal は「ブロックしない」という意図と
// 実装が乖離していたため、右上の非ブロッキング通知（notification）へ変更した。
// Issue #76 Codexレビュー対応: dismissInitialPasswordWarning への依存を
// useEffect の依存配列から外し、ref 経由で常に最新の関数を参照する形にした。
// AuthContext 側の関数参照が（ログイン直後の setUser 等、警告の表示/非表示
// とは無関係な再レンダーで）変わっただけで、この effect のクリーンアップ
// （notification.destroy）が再実行されないようにするため。antd 5.12.2 では
// key 付き destroy は close 扱いになり onClose 経由の dismiss を誤発火する。

import { ExclamationCircleOutlined } from "@ant-design/icons";
import { notification } from "antd";
import { useContext, useEffect, useRef } from "react";
import AuthContext from "../context/AuthContext";

export const AUTO_CLOSE_MS = 8000;

const NOTIFICATION_KEY = "initial-password-warning";

const InitialPasswordWarningModal = () => {
	const { showInitialPasswordWarning, dismissInitialPasswordWarning } =
		useContext(AuthContext);

	// 最新の dismiss 関数を常に指すようにする（この ref の更新自体は
	// 下の表示/非表示 effect の再実行を引き起こさない）
	const dismissRef = useRef(dismissInitialPasswordWarning);
	useEffect(() => {
		dismissRef.current = dismissInitialPasswordWarning;
	}, [dismissInitialPasswordWarning]);

	// この effect は showInitialPasswordWarning の変化にのみ反応する。
	// dismissInitialPasswordWarning を依存配列に含めない（含めると、
	// 警告フラグとは無関係な再レンダーで参照が変わるたびにクリーンアップ
	// = notification.destroy が走り、onClose 経由で dismiss が誤発火する）。
	useEffect(() => {
		if (!showInitialPasswordWarning) {
			notification.destroy(NOTIFICATION_KEY);
			return undefined;
		}

		notification.warning({
			key: NOTIFICATION_KEY,
			placement: "topRight",
			duration: AUTO_CLOSE_MS / 1000,
			message: (
				<span>
					<ExclamationCircleOutlined
						style={{ color: "#faad14", marginRight: 8 }}
					/>
					Security Notice
				</span>
			),
			description: (
				<p>
					Your password is still the initial password. For your security, please
					change it from <strong>My Profile &gt; Change Password</strong>.
				</p>
			),
			onClose: () => dismissRef.current(),
		});

		return () => {
			notification.destroy(NOTIFICATION_KEY);
		};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [showInitialPasswordWarning]);

	return null;
};

export default InitialPasswordWarningModal;
